import { ConfirmDeleteTransactionComponent } from './confirm-delete-transaction/confirm-delete-transaction.component';
import { OnInit } from '@angular/core/';
import { Component, ViewContainerRef } from '@angular/core';
import { NavigationBarService } from 'app/header/navigationbar/navigation-bar.service';
import { MdDialogRef, MdDialogConfig, MdDialog } from '@angular/material';

@Component({
    templateUrl: 'delete-client-transaction.component.html',
    styleUrls: ['delete-client-transaction.component.css']
})
export class DeleteClientTransactionComponent implements OnInit {
    myClients = [];
    search: any;

    constructor(
        private navigationBarService: NavigationBarService,
        public dialogRef: MdDialogRef<any>,
        private dialog: MdDialog,
        private viewContainerRef: ViewContainerRef,
    ) { }

    ngOnInit() {
        this.getMyClients();
    }

    getMyClients() {
        this.navigationBarService.fetchMyClients()
            .subscribe(
            response => {
                if (response.arrResult.length != 0) {
                    this.myClients = this.myClients.concat(response.arrResult);
                }
            }
            );
    }


    confirmDelete(client) {
        const config = new MdDialogConfig();
        config.disableClose = true;
        config.viewContainerRef = this.viewContainerRef;
        this.dialogRef = this.dialog.open(ConfirmDeleteTransactionComponent, config);
        this.dialogRef.componentInstance.client = client;
    }
}




// WEBPACK FOOTER //
// ./src/app/header/navigationbar/delete-client-transaction/delete.client.transaction.component.ts